var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('social-media-mentions',{attrs:{"title":_vm.$t('Dashboard.Block.SocialMediaMentions.Title'),"subtitle":_vm.$t('Dashboard.Block.SocialMediaMentions.Subtitle'),"is-dashboard":true}})}
var staticRenderFns = []

export { render, staticRenderFns }